<template>
<div > 
    <div class="conteneur" > 
     
    </div>
        <!-- Desktop -->
            <!-- Titre -->    
            <h1 class=" h1Desktop is-hidden-mobile " > <span style="color: white;">FOB</span><span style="color: black;">ware <em>SI</em> </span></h1>
             <!-- Sous-Titre --> 
            <h2  class=" h2Desktop is-size-5 is-hidden-mobile  " style="width:70%;" >Cabinet   de   conseil   en   système   d’information</h2>
             <!-- Bouton --> 
           <a><span  v-on:click="scrollFix('#1')"> <router-link style="padding-top:1.5%;"  to="/AboutPage"><button class="button is-rounded is-hidden-mobile ">DECOUVRIR</button></router-link></span></a>
        
        <!-- Mobile -->
            
            <!-- Titre --> 
            <h1 class="h1Mobile is-hidden-desktop is-hidden-tablet" > <span style="color: white;">FOB</span><span style="color: black;">ware <em>SI</em> </span></h1>
             <!-- Sous-Titre --> 
            <h2  class="h2Mobile  is-hidden-desktop is-hidden-tablet " style="width:70%;" >Cabinet   de   conseil   en   système   d’information</h2>
             <!-- Bouton --> 
            <a><span  v-on:click="scrollFix('#1')"> <router-link style="padding-top:1.5%;"  to="/AboutPage"><button class="button is-rounded is-hidden-desktop is-hidden-tablet">DECOUVRIR</button></router-link></span></a>
    </div>
</template>

<script>

export default {
  name: "Home",
   components: {
   
  },
   methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang;
    }
  }
};
</script>
<style scoped>   
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');

.conteneur{
    background-image:url("../../public/assets/img/nantes.png");
    height: 100vh;
    background-position: center;
    background-size:cover;
    background-repeat: no-repeat;

}
.h2Desktop{
    position: absolute;
    left: 50%;                        
    top: 50%;                         
    transform: translate(-50%, -50%); 
    color:white;
    font-family: 'Lato', sans-serif;
    letter-spacing:0.3em;
}
.h1Desktop {
    position: absolute;
    left: 50%;    
    top: 40%;                                               
    transform: translate(-50%, -50%); 
    font-family: 'Spartan', sans-serif;
    font-weight: bolder;
    font-size: 70px;
}

.h2Mobile{
    position: absolute;
    left: 48%;                        
    top: 50%;                         
    transform: translate(-50%, -50%); 
    color:white;
    font-family: 'Lato', sans-serif;
    letter-spacing:0.3em;
    font-size: 12px;
}
.h1Mobile {
    position: absolute;
   left: 48%; 
    top: 40%;                                               
    transform: translate(-50%, -50%); 
    font-family: 'Spartan', sans-serif;
    font-weight: bolder;
    font-size: 29px;
}


.button{
    position: absolute;
    background-color :transparent;
    border-color: black;
    color:white;
    transform: translate(-50%, -50%);
    width:18vh ;
    top:60%;    
    height: 5%;  
    font-size: 2vh;                      
    
}
.button:hover {
    color:black;
    background-color:rgba(255, 255, 255, 0.2)
}



</style>